import { ArrowDownIcon } from '@heroicons/react/24/outline'

import { anim, stagger } from '../../../../motion'
import { useCopy } from '../../../i18n'
import { MaskText, Odometer } from '../../stage/fx'
import { useBranch } from '../branch'

// Partikel bilden den Schriftzug, dann einen Ring um das Versprechen, dann drei Ringe um die Zahlen
export const INTRO_PARTICLES = [
  [
    0,
    (w, h) => ({
      type: 'text',
      text: 'Aivy',
      x: w / 2,
      y: h * 0.44,
      size: Math.min(w * 0.34, h * 0.44)
    })
  ],
  [
    0.34,
    (w, h) => ({ type: 'ring', x: w / 2, y: h / 2, r: Math.min(w, h) * 0.44 })
  ],
  [
    0.66,
    (w, h, narrow) => ({
      type: 'rings',
      centers: narrow
        ? [
            [w / 2, h * 0.27],
            [w / 2, h * 0.5],
            [w / 2, h * 0.73]
          ]
        : [
            [w * 0.2, h * 0.47],
            [w * 0.5, h * 0.47],
            [w * 0.8, h * 0.47]
          ],
      r: narrow ? h * 0.1 : Math.min(w * 0.13, h * 0.24)
    })
  ],
  [1, () => ({ type: 'scatter', alpha: 0.35 })]
]

export default function DmsIntro() {
  const c = useCopy('show')
  const ui = useCopy('ui')
  const b = useCopy('branches')
  const branch = useBranch()
  const trust =
    branch.id === 'allgemein' ? b.trust : `${b.trustIn} ${b.names[branch.id]}`

  return (
    <div className='sc-full'>
      <div
        className='dms-intro__kicker'
        style={anim({ at: [-1, 0], out: [0.12, 0.18], oy: -30 })}
      >
        <span className='sc-eyebrow'>{c.kicker}</span>
      </div>

      <h1 className='sc-display dms-intro__title'>
        <MaskText text={c.title} at={[0.24, 0.4]} out={[0.56, 0.62]} />
      </h1>

      <div className='dms-intro__stats'>
        {c.stats.map((s, i) => (
          <div
            key={s.label}
            className='dms-intro__stat'
            style={anim({ at: stagger(0.62, 0.04, 0.08, i), y: 40, s: 0.9 })}
          >
            <Odometer
              value={s.value}
              at={stagger(0.63, 0.04, 0.14, i)}
              className='sc-num dms-intro__num'
            />
            <div className='dms-intro__label'>{s.label}</div>
          </div>
        ))}
      </div>

      <div className='dms-trust' style={anim({ at: [0.82, 0.9], y: 40 })}>
        <div className='dms-trust__label'>{trust}</div>
        <div className='dms-trust__logos' key={branch.id}>
          {branch.logos.map((src, i) => (
            <img
              key={src}
              src={src}
              alt=''
              style={{ animationDelay: `${i * 80}ms` }}
            />
          ))}
        </div>
      </div>

      <div
        className='sc-cue'
        style={anim({ at: [-1, 0], out: [0.03, 0.08], oy: 20 })}
      >
        <ArrowDownIcon width={16} height={16} />
        {ui.cue}
      </div>
    </div>
  )
}
